var _g, _path, _g2, _g3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _g13, _g14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBaby12Months(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 170,
    viewBox: "0 0 114 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.9701 69.483C15.5932 70.2872 12.8326 69.6645 12.8326 69.6645C12.8326 69.6645 11.8214 72.3685 10.9404 72.2592C10.0595 72.1491 9.86485 69.2946 9.86485 69.2946C9.86485 69.2946 6.91423 69.2046 6.74595 68.333C6.57845 67.4614 9.29953 66.3571 9.29953 66.3571C9.29953 66.3571 8.40623 63.5592 9.18324 63.1304C9.96026 62.7016 11.9183 64.9116 11.9183 64.9116C11.9183 64.9116 14.2362 63.2343 14.8844 63.8407C15.5327 64.4472 14.102 66.955 14.102 66.955C14.102 66.955 16.347 68.6789 15.9701 69.483Z",
    fill: "#FFF1C8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.8521 42.9459C10.5365 43.6198 8.22249 43.0987 8.22249 43.0987C8.22249 43.0987 7.37492 45.3654 6.63668 45.2731C5.89844 45.1808 5.73479 42.7885 5.73479 42.7885C5.73479 42.7885 3.26108 42.7133 3.12072 41.9828C2.98037 41.2523 5.26101 40.3264 5.26101 40.3264C5.26101 40.3264 4.51189 37.9814 5.16328 37.6224C5.81467 37.2633 7.45555 39.1151 7.45555 39.1151C7.45555 39.1151 9.39808 37.7092 9.94168 38.2179C10.4853 38.7266 9.28644 40.8281 9.28644 40.8281C9.28644 40.8281 11.1677 42.272 10.8521 42.9459Z",
    fill: "#FFF1C8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M113.263 57.473C112.723 58.6246 108.768 57.7336 108.768 57.7336C108.768 57.7336 107.319 61.6078 106.057 61.4504C104.796 61.293 104.517 57.2032 104.517 57.2032C104.517 57.2032 100.289 57.0745 100.048 55.826C99.8079 54.5775 103.707 52.9947 103.707 52.9947C103.707 52.9947 102.427 48.9864 103.54 48.3722C104.654 47.7572 107.459 50.9242 107.459 50.9242C107.459 50.9242 110.78 48.5211 111.708 49.3904C112.636 50.2597 110.588 53.8524 110.588 53.8524C110.588 53.8524 113.802 56.3215 113.263 57.473Z",
    fill: "#FFF1C8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M55.6342 170C85.6753 170 110.028 165.571 110.028 160.107C110.028 154.644 85.6753 150.215 55.6342 150.215C25.5931 150.215 1.23999 154.644 1.23999 160.107C1.23999 165.571 25.5931 170 55.6342 170Z",
    fill: "#27AE60",
    fillOpacity: 0.54
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M103.407 104.994C103.766 105.529 104.057 106.109 104.271 106.717C104.358 106.966 104.418 107.281 104.225 107.461C104.074 107.602 103.837 107.587 103.635 107.545C102.437 107.297 101.695 106.454 101.026 105.491C101.586 106.344 101.956 107.32 102.101 108.33C102.136 108.572 102.153 108.836 102.02 109.041C101.865 109.28 101.541 109.362 101.261 109.313C100.879 109.245 100.542 109.004 100.271 108.737C99.7092 108.181 99.2059 107.565 98.7732 106.904C98.9679 107.538 99.7728 109.756 98.3545 109.589C98.0109 109.549 97.7574 109.259 97.5441 108.987C96.878 108.137 96.2568 107.254 95.6566 106.357C95.1339 105.575 94.4826 104.772 94.1739 103.882C93.6939 102.5 92.4307 101.321 91.1046 100.78C78.743 95.7314 70.8061 83.6116 68.8954 70.6591C68.5573 68.3691 68.603 65.6022 70.5044 64.2816C72.343 63.0044 74.8827 63.828 76.8222 64.9462C81.6269 67.7177 84.7978 71.768 87.7182 76.3587C91.2434 81.9002 94.5027 87.6774 96.7609 93.8253C97.1416 94.8628 98.242 95.6143 99.1656 96.1594C100.662 97.0427 102.598 97.4638 104.197 98.1787C104.633 98.3734 105.067 98.6789 104.854 99.1985C104.672 99.6428 104.173 99.7429 103.751 99.77C103.221 99.8041 102.625 99.9801 102.118 99.7452C102.77 100.103 103.257 100.875 103.715 101.443C104.365 102.25 105.124 103.238 105.459 104.22C105.538 104.451 105.609 104.69 105.6 104.935C105.59 105.179 105.489 105.431 105.286 105.567C105.086 105.701 104.819 105.702 104.591 105.626C103.865 105.385 103.296 104.766 102.806 104.208C103.02 104.456 103.222 104.718 103.407 104.994Z",
    fill: "#876855"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M66.7931 66.0772C63.226 75.3874 68.8279 82.9257 68.8279 82.9257C68.8279 82.9257 77.1052 84.2913 87.6469 72.7059C87.6469 72.7059 76.3461 54.3289 66.7931 66.0772Z",
    fill: "#2F80ED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    opacity: 0.5,
    d: "M66.7931 66.0772C63.226 75.3874 68.8279 82.9257 68.8279 82.9257C68.8279 82.9257 77.1052 84.2913 87.6469 72.7059C87.6469 72.7059 76.3461 54.3289 66.7931 66.0772Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M87.7687 71.6465C83.5075 77.2981 75.6489 82.3727 68.1843 82.396",
    stroke: "#FFE4A9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    opacity: 0.5,
    d: "M86.5596 84.2041C85.557 84.5763 84.7225 85.3789 84.3115 86.3661",
    stroke: "#1D1D1B",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    opacity: 0.5,
    d: "M102.709 102.556C101.618 104.252 99.8976 105.533 97.9597 106.089",
    stroke: "#1D1D1B",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M51.6524 67.1636C50.217 65.4762 47.9922 64.6604 45.803 64.3177C41.8885 63.7058 39.4047 66.6751 36.6549 68.8937C33.4429 71.4845 30.531 74.4476 28.0007 77.7068C27.6161 78.1961 25.4835 78.0798 24.9074 78.1551C23.6697 78.3156 22.4414 78.549 21.2309 78.8537C18.8099 79.4625 16.461 80.3558 14.2486 81.5144C14.0827 81.6012 13.9322 81.6586 13.7857 81.7067C13.0443 81.7338 12.2618 81.5687 11.5918 81.3926C9.91064 80.9498 8.25041 79.8704 6.61806 79.2376C6.17294 79.0654 5.65027 78.9708 5.43082 79.4881C5.24316 79.9301 5.52387 80.355 5.80071 80.6745C6.14889 81.0754 6.44354 81.6221 6.96698 81.8176C6.25355 81.6059 5.36176 81.8028 4.63671 81.8765C3.60611 81.982 2.37082 82.1378 1.43716 82.5899C1.2177 82.6962 0.997482 82.8148 0.830757 82.9932C0.664032 83.1715 0.556208 83.4205 0.601961 83.6609C0.646938 83.8974 0.834621 84.0874 1.04942 84.1967C1.73106 84.5441 2.57089 84.5115 3.31301 84.4681C2.98266 84.4875 2.65388 84.5286 2.32896 84.5906C1.69618 84.7116 1.07888 84.9132 0.496508 85.1885C0.25844 85.3017 -0.00833074 85.4809 0.000199372 85.7445C0.00640309 85.9516 0.18402 86.1082 0.356173 86.223C1.37436 86.9 2.49565 86.8333 3.65109 86.6324C2.65074 86.8341 1.69695 87.2582 0.877283 87.8654C0.68109 88.0104 0.481018 88.1849 0.429062 88.423C0.3678 88.7014 0.536824 88.9898 0.769464 89.1542C1.08663 89.3783 1.49532 89.4481 1.8753 89.452C2.66627 89.4605 3.458 89.3853 4.23269 89.2271C3.64489 89.535 1.50229 90.5229 2.61895 91.4132C2.88959 91.6288 3.27344 91.6055 3.61697 91.5659C4.68944 91.4419 5.75416 91.262 6.81344 91.0572C7.73702 90.8789 8.76609 90.7765 9.61522 90.3709C11.177 89.6249 12.8784 90.1321 14.482 90.4834C16.1268 90.844 17.6777 91.4349 19.2907 91.8862C20.8098 92.3112 22.5197 92.3817 24.1017 92.4306C27.4152 92.5329 30.7528 92.1219 33.9152 91.1146C40.1251 89.1372 45.5386 86.3052 49.2283 80.6815C51.4159 77.347 54.7224 70.7711 51.6524 67.1636Z",
    fill: "#876855"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M50.2347 66.5136C53.8018 75.8239 48.1998 83.3621 48.1998 83.3621C48.1998 83.3621 39.9225 84.7277 29.3809 73.1423C29.3809 73.1423 40.681 54.7653 50.2347 66.5136Z",
    fill: "#2F80ED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    opacity: 0.5,
    d: "M50.2347 66.5136C53.8018 75.8239 48.1998 83.3621 48.1998 83.3621C48.1998 83.3621 39.9225 84.7277 29.3809 73.1423C29.3809 73.1423 40.681 54.7653 50.2347 66.5136Z",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M29.2593 72.083C33.5205 77.7346 41.379 82.8092 48.8436 82.8325",
    stroke: "#FFE4A9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    opacity: 0.5,
    d: "M29.1096 79.5059C29.7145 80.3271 30.3201 81.1483 30.925 81.9695",
    stroke: "#1D1D1B",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    opacity: 0.5,
    d: "M4.85775 84.1738C4.56617 86.1342 4.99036 88.1931 6.03259 89.8781",
    stroke: "#1D1D1B",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M72.3488 60.782C73.3786 61.9056 74.2339 63.1565 74.8542 64.5143C78.9433 73.4624 81.3208 83.2239 81.8683 93.0437C82.2429 99.7669 81.5744 107.035 77.2861 112.228C72.8559 117.592 65.5185 119.568 58.5866 120.161C54.8597 120.48 51.0591 120.48 47.4354 119.555C43.8109 118.63 40.3531 116.709 38.0911 113.731C34.7015 109.267 34.4471 103.215 34.7402 97.6181C35.2451 87.9806 36.9705 78.4099 39.8459 69.1981C42.1196 61.9149 48.2543 55.574 56.1624 54.6589C61.8125 54.0044 68.3768 56.4464 72.3488 60.782Z",
    fill: "#2F80ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M48.6931 63.4118C51.5794 65.877 55.3861 67.2387 59.1812 67.1635C62.9764 67.0883 66.7265 65.5776 69.5128 63",
    stroke: "#FFE4A9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    opacity: 0.8,
    d: "M40.8477 9.85254C34.7177 11.474 29.5282 16.2881 27.4515 22.2786C25.3748 28.2691 26.4721 35.263 30.2835 40.3299",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    opacity: 0.8,
    d: "M76.7595 6.86719C80.4104 8.8012 82.2614 13.4462 81.2572 17.4538C80.2538 21.4622 76.6688 24.6028 72.6185 25.4179C68.5683 26.2336 64.2187 24.8479 61.1277 22.1066",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    opacity: 0.8,
    d: "M83.2361 17.5166C83.2687 19.7972 82.4956 22.0818 81.085 23.8746C79.6744 25.6675 77.635 26.9556 75.4102 27.4596",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M80.3645 34.8805C80.0001 37.7714 82.2737 40.4956 82.5909 43.4028C83.4982 51.7251 77.4883 59.8814 70.4735 63.7595C64.9304 66.8242 58.3336 66.6326 52.2578 65.706C48.755 65.1717 45.2732 64.069 42.4086 61.983C38.0971 58.8431 36.2949 54.0817 33.6629 49.6872C30.3711 44.1884 27.847 37.7598 28.1595 31.2622C28.3386 27.5376 29.3413 23.8743 31.1 20.5848C35.8816 11.6452 45.5787 6.24333 55.6047 6.02775C58.8787 5.95718 62.1675 6.34181 65.3383 7.1576C70.5495 8.49838 75.0728 11.988 77.8605 16.5694C81.1943 22.0473 81.4603 28.479 80.3963 34.6641C80.3847 34.7355 80.3738 34.8076 80.3645 34.8805Z",
    fill: "#876855"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M28.2277 43.3871C26.5062 44.2393 25.9564 46.5564 26.4985 48.3989C27.0405 50.2414 28.3937 51.7164 29.705 53.1192C30.2083 53.6574 30.7279 54.2079 31.3917 54.5282C32.3075 54.9702 33.4001 54.9152 34.3663 54.6003C35.3333 54.2847 36.2003 53.7303 37.0564 53.1812C37.2324 53.0688 37.4163 52.947 37.5101 52.7602C38.0963 51.5962 36.5594 47.2187 35.7141 46.1067C34.2818 44.2231 30.5417 42.241 28.2277 43.3871Z",
    fill: "#876855"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    opacity: 0.3,
    d: "M77.3179 40.7023C76.2059 40.4735 74.9915 40.6837 74.0307 41.3025C71.9184 42.6627 71.1576 45.4869 72.6171 47.5326C73.1707 48.3088 73.9113 49.0083 74.8349 49.2456C75.2793 49.3596 75.7445 49.3611 76.2021 49.3355C76.7969 49.3022 77.3947 49.2223 77.9561 49.0222C80.9564 47.956 81.3752 43.2047 78.8479 41.3676C78.3912 41.0357 77.867 40.8155 77.3179 40.7023Z",
    fill: "#1D1D1B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    opacity: 0.3,
    d: "M47.6181 42.7878C46.3898 42.535 45.0482 42.7677 43.9874 43.4509C41.654 44.9529 40.8142 48.0726 42.4263 50.3316C43.0382 51.1884 43.8555 51.9616 44.8753 52.2229C45.3661 52.3485 45.8795 52.3509 46.3859 52.3222C47.0427 52.285 47.7026 52.1965 48.323 51.9763C51.6365 50.7992 52.0987 45.5516 49.3078 43.523C48.8038 43.1562 48.2245 42.9127 47.6181 42.7878Z",
    fill: "#1D1D1B"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M29.7406 45.0393C28.4215 45.1448 27.4436 46.5895 27.7546 47.8527C27.7972 48.0249 28.0283 47.9861 28.0981 47.8643C28.7596 46.7104 28.7542 45.5728 30.4687 45.7977C29.8918 46.7399 29.7367 48.525 30.4757 49.3152C30.6339 49.4843 30.9092 49.4036 30.903 49.1539C30.8875 48.5979 30.6533 48.0807 30.6626 47.5076C30.6719 46.9322 30.8689 46.4452 31.0255 45.9133C31.9103 46.163 32.6912 46.7019 33.3659 47.313C33.4589 47.3975 33.6334 47.2827 33.5729 47.1641C32.9269 45.9024 31.169 44.9253 29.7406 45.0393Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M51.5706 33.69C51.8203 33.6396 52.0754 33.5838 52.2902 33.4473C52.5051 33.3108 52.6757 33.0759 52.664 32.8215C52.6516 32.5478 52.4306 32.3175 52.1755 32.2167C51.9211 32.1158 51.6381 32.1197 51.3643 32.1383C50.0522 32.2275 48.7611 32.6176 47.6258 33.2806C47.4552 33.3806 47.283 33.49 47.166 33.6497C46.4006 34.6904 48.1772 34.2104 48.5114 34.1724C49.5381 34.0568 50.5587 33.8963 51.5706 33.69Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M75.7659 32.482C76.1063 32.475 76.5506 32.3788 76.5809 32.04C76.6111 31.7088 76.2087 31.5289 75.883 31.4622C74.4995 31.1776 73.0758 31.09 71.6683 31.2032C70.2647 31.3157 69.6032 32.6037 71.4 32.5681C72.8555 32.5394 74.3111 32.5106 75.7659 32.482Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M66.4131 43.8438C66.1309 42.1851 64.1046 41.9757 62.7855 42.3448C62.7173 42.3642 62.7436 42.4518 62.8041 42.458C63.9627 42.579 66.0037 42.4635 65.9905 44.1734C65.9804 45.5289 64.6187 46.2353 63.5571 46.7223C63.3408 46.8216 63.5122 47.2047 63.7316 47.1054C65.022 46.523 66.7001 45.5273 66.4131 43.8438Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M62.3654 53.6395C60.4593 53.6945 58.6912 53.5565 57.024 52.5174C55.4893 51.5604 54.641 50.2468 53.6693 48.7789C53.6081 48.6866 53.4816 48.7548 53.501 48.8556C54.2377 52.6732 58.8556 55.0593 62.467 54.256C62.8182 54.1769 62.7136 53.6294 62.3654 53.6395Z",
    fill: "#4E4E4E"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_385_1452",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 35,
    width: 9,
    height: 6
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000012432062812764547150000004837157978257738937_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M76.3134 39.5118C75.5914 39.8863 74.7834 40.1562 73.9397 40.3113C72.7602 40.5338 71.5086 40.5362 70.3253 40.3392C69.5226 40.205 68.7425 39.9802 68.0415 39.6622C68.3602 38.9945 68.7115 38.309 69.1396 37.7127C69.6227 37.0241 70.2159 36.4471 70.989 36.1369C72.0964 35.6941 73.4038 35.9291 74.3786 36.61C74.6221 36.7759 74.8501 36.9752 75.0532 37.1838L75.0618 37.1916C75.6728 37.8337 76.0916 38.6533 76.3134 39.5118Z",
    fill: "white"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_385_1452)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M76.3134 39.5118C75.5914 39.8863 74.7834 40.1562 73.9397 40.3113C72.7602 40.5338 71.5086 40.5362 70.3253 40.3392C69.5226 40.205 68.7425 39.9802 68.0415 39.6622C68.3602 38.9945 68.7115 38.309 69.1396 37.7127C69.6227 37.0241 70.2159 36.4471 70.989 36.1369C72.0964 35.6941 73.4038 35.9291 74.3786 36.61C74.6221 36.7759 74.8501 36.9752 75.0532 37.1838L75.0618 37.1916C75.6728 37.8337 76.0916 38.6533 76.3134 39.5118Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_385_1452",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 35,
    width: 9,
    height: 6
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000012432062812764547150000004837157978257738937__2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M76.3134 39.5118C75.5914 39.8863 74.7834 40.1562 73.9397 40.3113C72.7602 40.5338 71.5086 40.5362 70.3253 40.3392C69.5226 40.205 68.7425 39.9802 68.0415 39.6622C68.3602 38.9945 68.7115 38.309 69.1396 37.7127C69.6227 37.0241 70.2159 36.4471 70.989 36.1369C72.0964 35.6941 73.4038 35.9291 74.3786 36.61C74.6221 36.7759 74.8501 36.9752 75.0532 37.1838L75.0618 37.1916C75.6728 37.8337 76.0916 38.6533 76.3134 39.5118Z",
    fill: "white"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_385_1452)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M70.3851 36.206C69.1513 36.7534 68.341 38.133 68.4643 39.4776C68.5876 40.8223 69.636 42.0312 70.9488 42.3437C72.2625 42.657 73.7429 42.0506 74.4594 40.9068C76.1282 38.2454 73.2566 34.9326 70.3851 36.206Z",
    fill: "#4E505B"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_385_1452",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 36,
    width: 9,
    height: 6
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000078008260902243304180000003267571084682938497_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M55.6 40.0948C54.8773 40.4693 54.07 40.7392 53.2263 40.8943C52.0468 41.1168 50.7952 41.1192 49.6119 40.9222C48.8093 40.788 48.0291 40.5631 47.3281 40.2452C47.6468 39.5775 47.9981 38.892 48.4261 38.2957C48.9093 37.6071 49.5025 37.0301 50.2756 36.7199C51.383 36.2772 52.6905 36.5121 53.6652 37.193C53.9087 37.3589 54.1367 37.5582 54.3399 37.7668L54.3484 37.7746C54.9602 38.4167 55.3782 39.2363 55.6 40.0948Z",
    fill: "white"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_385_1452)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M55.6 40.0938C54.8773 40.4683 54.07 40.7382 53.2263 40.8933C52.0468 41.1159 50.7952 41.1182 49.6119 40.9212C48.8093 40.7871 48.0291 40.5622 47.3281 40.2442C47.6468 39.5765 47.9981 38.8911 48.4261 38.2947C48.9093 37.6061 49.5025 37.0292 50.2756 36.719C51.383 36.2762 52.6905 36.5112 53.6652 37.192C53.9087 37.358 54.1367 37.5573 54.3399 37.7659L54.3484 37.7736C54.9602 38.4157 55.3782 39.2353 55.6 40.0938Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_385_1452",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 36,
    width: 9,
    height: 6
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000078008260902243304180000003267571084682938497__2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M55.6 40.0948C54.8773 40.4693 54.07 40.7392 53.2263 40.8943C52.0468 41.1168 50.7952 41.1192 49.6119 40.9222C48.8093 40.788 48.0291 40.5631 47.3281 40.2452C47.6468 39.5775 47.9981 38.892 48.4261 38.2957C48.9093 37.6071 49.5025 37.0301 50.2756 36.7199C51.383 36.2772 52.6905 36.5121 53.6652 37.193C53.9087 37.3589 54.1367 37.5582 54.3399 37.7668L54.3484 37.7746C54.9602 38.4167 55.3782 39.2363 55.6 40.0948Z",
    fill: "white"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_385_1452)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M49.6764 36.5039C48.4426 37.0513 47.6322 38.4309 47.7555 39.7755C47.8788 41.1202 48.9273 42.3291 50.2401 42.6416C51.5538 42.9549 53.0341 42.3485 53.7507 41.2047C55.4187 38.5425 52.5472 35.2305 49.6764 36.5039Z",
    fill: "#4E505B"
  })))))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    opacity: 0.8,
    d: "M48.2339 13.4951C52.5338 18.8388 62.7615 22.779 69.5724 21.9647C71.3366 21.7538 73.1566 21.2653 74.4407 20.0377C75.7249 18.8094 76.2708 16.6753 75.2674 15.2097",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    opacity: 0.8,
    d: "M45.6912 14.6484C37.7187 18.3505 32.9643 28.05 32.416 35.3208",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    opacity: 0.8,
    d: "M48.6272 11.043C51.0567 13.1716 55.8111 17.6476 61.6899 17.798C65.8347 17.9043 69.3879 16.5588 71.1304 13.8385",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    opacity: 0.8,
    d: "M44.251 11.3662C38.2179 12.1688 32.8285 16.6541 30.9441 22.4414",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    opacity: 0.8,
    d: "M63.3169 23.5823C66.2388 24.7494 69.5005 25.051 72.5876 24.4392C75.035 23.9545 77.4893 22.7991 78.8316 20.6968C80.174 18.5945 79.9987 15.4291 77.984 13.958",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    opacity: 0.8,
    d: "M64.7629 19.3222C68.6271 19.6959 72.6045 17.3641 74.1663 13.8094C75.7273 10.2547 74.7541 5.74843 71.8639 3.15527",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    opacity: 0.8,
    d: "M39.0974 16.2441C32.9464 20.8046 29.2653 28.5112 29.5833 36.1612",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    opacity: 0.8,
    d: "M45.2175 9.08136C42.1327 7.75764 38.4934 7.79021 35.4334 9.16976C32.3734 10.5493 29.9384 13.2541 28.8877 16.4428",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    opacity: 0.8,
    d: "M49.0374 9.09549C52.0105 12.0686 55.621 14.4384 60.6274 14.7161C64.4536 14.9285 66.5101 13.7979 68.2975 12.6091C70.085 11.4203 71.28 9.25756 71.004 7.12891",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    opacity: 0.8,
    d: "M49.9602 8.17195C52.2106 9.69496 57.4589 11.2459 60.1692 11.0559C62.8794 10.8659 65.516 9.74304 67.5315 7.91992",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    opacity: 0.8,
    d: "M47.3159 6.75307C49.7928 3.49844 53.6925 1.36902 57.7692 1.0441C61.8458 0.719177 66.0341 2.20419 68.9948 5.02455",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    opacity: 0.8,
    d: "M50.7644 6.41007C52.8388 4.67303 55.5219 3.67811 58.2267 3.64166C60.9323 3.60522 63.6402 4.52802 65.7611 6.20845",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    opacity: 0.8,
    d: "M52.7114 7.2514C54.4539 7.97723 56.4058 8.08114 58.2793 7.85083C60.1528 7.62052 61.9705 7.06994 63.7766 6.52246",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    opacity: 0.8,
    d: "M46.9522 16.5586C45.4641 22.9981 41.3331 28.7846 35.7273 32.285",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    opacity: 0.8,
    d: "M43.7889 19.4502C41.3648 22.5846 38.9407 25.719 36.5166 28.8535",
    stroke: "#4E4E4E",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M51.2509 148.653C53.4238 143.753 53.551 137.932 52.1265 132.837C54.2985 128.2 56.3644 121.904 54.4552 117.184C51.4611 109.782 43.7801 103.891 34.8204 102.127C31.0866 117.774 33.3486 134.51 40.4022 149.264C39.6236 150.732 41.3862 154.377 43.0023 155.213C44.6192 156.05 46.8168 155.864 48.343 154.911C49.8691 153.959 50.5825 150.16 51.2509 148.653Z",
    fill: "#876855"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M37.7578 145.455C37.7679 146.696 38.0665 148.321 37.7912 149.525C37.4942 150.824 36.8374 150.674 35.5834 151.241C33.4664 152.198 31.5634 153.629 30.0714 155.411C29.0113 156.677 28.1196 158.317 28.5189 159.919C28.7903 161.01 29.6379 161.893 30.629 162.425C31.6192 162.957 32.746 163.178 33.8627 163.312C36.4194 163.62 38.2781 162.954 40.7263 162.739C43.4536 162.501 46.2437 162.63 48.826 161.561C49.6294 161.227 50.4025 160.776 50.9748 160.121C52.2233 158.69 52.2931 156.595 52.1272 154.704C51.9341 152.502 52.342 151.174 52.6561 149.144C52.9337 147.348 52.2008 147.414 50.3731 147.019C46.2298 146.123 41.9763 145.787 37.7578 145.455Z",
    fill: "#FF766F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M53.1624 147.841C48.0606 146.74 42.8704 146.049 37.6577 145.776",
    stroke: "#FFE4A9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M34.7737 101.901C38.6906 103.489 42.64 105.092 46.1482 107.448C49.6572 109.804 52.7381 112.999 54.2285 116.954",
    stroke: "#FFE4A9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    opacity: 0.5,
    d: "M50.8322 131.227C49.9591 130.856 49.0859 130.485 48.2119 130.114",
    stroke: "#1D1D1B",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M65.4348 148.155C63.262 143.255 63.134 137.434 64.5593 132.339C62.3872 127.702 60.3214 121.406 62.2306 116.686C65.2246 109.284 72.9064 103.393 81.8654 101.629C85.5992 117.276 83.3372 134.012 76.2836 148.766C77.0621 150.234 75.2995 153.879 73.6834 154.715C72.0666 155.552 69.8689 155.366 68.3428 154.413C66.8159 153.462 66.1025 149.662 65.4348 148.155Z",
    fill: "#876855"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M78.9271 144.956C78.917 146.197 78.6185 147.822 78.8938 149.026C79.1908 150.325 79.8476 150.175 81.1015 150.742C83.2186 151.699 85.1215 153.13 86.6135 154.912C87.6736 156.178 88.5654 157.818 88.166 159.42C87.8946 160.511 87.047 161.394 86.056 161.926C85.0649 162.458 83.939 162.679 82.8223 162.813C80.2656 163.121 78.4068 162.455 75.9586 162.24C73.2313 162.002 70.4412 162.131 67.8589 161.062C67.0555 160.728 66.2824 160.277 65.7101 159.622C64.4616 158.191 64.3918 156.096 64.5577 154.205C64.7508 152.003 64.343 150.675 64.0289 148.645C63.7513 146.849 64.4841 146.915 66.3119 146.52C70.4552 145.625 74.7086 145.289 78.9271 144.956Z",
    fill: "#FF766F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M63.5227 147.342C68.6245 146.241 73.8147 145.55 79.0274 145.277",
    stroke: "#FFE4A9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M62.4817 115.793C66.2171 108.321 73.6693 102.825 81.9118 101.465",
    stroke: "#FFE4A9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    opacity: 0.5,
    d: "M66.1243 131.109C67.0106 130.04 68.2545 129.271 69.6077 128.958",
    stroke: "#1D1D1B",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaby12Months);
export default __webpack_public_path__ + "static/media/baby-12-months.6d4593e7122e06505eba57e2ab9ccdb9.svg";
export { ForwardRef as ReactComponent };